/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1CashBalanceState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_CASH_BALANCE_STATE_ENTITY_NAME = 'ixc.portfolio.v1.CashBalance';
export const ixcPortfolioV1CashBalanceStateEntity = new schema.Entity<IxcPortfolioV1CashBalanceState>(IXC_PORTFOLIO_V1_CASH_BALANCE_STATE_ENTITY_NAME, {}, { idAttribute: 'accountId' });

